import { useElements, useStripe } from "@stripe/react-stripe-js";
import { confirmStripePayment, confirmStripeSetup } from "../lib/helpers/stripeWrappers";
import { QUERY_PARAM_PLAN, ROUTE_WELCOME_ONBOARD } from "../lib/constants";
import { StripePlanId } from "../lib/types";

// Carries the chosen plan across the Stripe redirect so trial-start charges it.
// No planId (control) keeps the plain /welcome-onboard url unchanged.
export const buildSuccessReturnUrl = (planId?: StripePlanId): string =>
  `${window.location.origin}${ROUTE_WELCOME_ONBOARD}${
    planId ? `?${QUERY_PARAM_PLAN}=${planId}` : ""
  }`;

const usePaymentAttempt = (planId?: StripePlanId) => {
  const stripe = useStripe();
  const elements = useElements();

  const returnUrl = buildSuccessReturnUrl(planId);

  const setupAttemptHandler = confirmStripeSetup(stripe, elements, returnUrl);
  const paymentAttemptHandler = confirmStripePayment(stripe, elements, returnUrl);

  return { setupAttemptHandler, paymentAttemptHandler, successReturnUrl: returnUrl };
};

export default usePaymentAttempt;
